<script lang="ts" setup>
import { InputLabel } from '../../InputLabel';

defineProps<{ label?: string }>();
</script>

<template>
  <InputLabel
    v-if="label"
    :label="label"
  />

  <ul class="border border-gray-200 rounded-md divide-y divide-gray-200">
    <slot />
  </ul>
</template>
